import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const PowerSavingContainer = styled.div<React.CSSProperties>`
  top: ${220 * Screen.widthRatio}px;
  left: ${140 * Screen.widthRatio}px;
  position: absolute;
`;

export default withAnimation(PowerSavingContainer);
